import React, { useContext, useEffect, useMemo } from 'react'
import {
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Flex,
  Text,
} from '@chakra-ui/react'
import rootStore from '../../../../store/RootStore'
import { ACLUserRoles } from '../ACLUserRoles/ACLUserRoles'

import { ACLContext } from '../../../../contexts/ACLContext'
import SearchDropdown from '../../../ui/SearchDropdown/SearchDropdown'
import { observer } from 'mobx-react'

const ACLReportUsers = observer(() => {
  const {
    // accessControlStore: { users },
    productsStore: { reports },
  } = rootStore

  const columnSizes = {
    firstCol: '200px',
    cols: '140px',
  }
  const [selectedReport, setSelectedReport] = React.useState([])

  const searchReportList = useMemo(() => {
    return reports
      ?.map(report => {
        return {
          label: `${report.product} - ${report.title}`,
          value: report.id,
        }
      })
      .sort((a, b) => {
        return a.label.localeCompare(b.label)
      })
  }, [reports])

  const { openUserManagerModal } = useContext(ACLContext)

  const handleReportChange = ({ item }) => {
    setSelectedReport(reports?.find(report => report.id === item.value))
  }

  if (!reports) return null
  return (
    <>
      <Card
        p={4}
        mb={8}
        backgroundColor="white">
        <CardHeader
          textStyle="h2"
          p={'16px'}>
          <SearchDropdown
            onChange={handleReportChange}
            items={searchReportList}
            placeholder="Select a Report..."
            emptyState={<Box textAlign={'center'}>Report not found.</Box>}
          />
        </CardHeader>
        <CardBody overflowX="auto">
          <Flex
            alignItems="center"
            borderBottom="1px solid"
            borderColor="brand.lightGray"
            pb="12px">
            <Flex
              key="-1"
              className="role-header"
              w={columnSizes.firstCol}
              minW={columnSizes.firstCol}
              overflow="hidden">
              <Text
                fontSize="14px"
                fontWeight="bold">
                User
              </Text>
            </Flex>
            {selectedReport?.sections?.map(section => (
              <Flex
                key={section.id}
                className="role-header"
                w={columnSizes.cols}
                minW={columnSizes.cols}
                alignItems="center"
                justifyContent="center">
                <Text
                  align="center"
                  fontSize="14px"
                  fontWeight="bold">
                  {section.title}
                </Text>
              </Flex>
            ))}
          </Flex>
          {/*{users?.map(user => (*/}
          {/*  <ACLUserRoles*/}
          {/*    key={user.id}*/}
          {/*    user={user}*/}
          {/*    report={selectedReport}*/}
          {/*    firstColWidth={columnSizes.firstCol}*/}
          {/*    colsWidth={columnSizes.cols}*/}
          {/*    data-testid={`userRole-${user.id}`}*/}
          {/*  />*/}
          {/*))}*/}
        </CardBody>
        <CardFooter>
          <Button
            colorScheme="orange"
            size="sm"
            onClick={() => openUserManagerModal(selectedReport.id)}>
            Edit Users / Roles
          </Button>
        </CardFooter>
      </Card>
    </>
  )
})

ACLReportUsers.propTypes = {}

export default ACLReportUsers
